import type { App } from 'vue';

import PtAffix from './affix';
import PtAlert from './alert';
import PtAvatar from './avatar';
import PtButton from './button';
import PtButtonV2 from './buttonv2';
import PtButtonGroup from './button-group';
import PtBacktop from './backtop';
import PtIcon from './icon';
import PtRow from './row';
import PtCol from './col';
import PtScrollbar from './scrollbar';
import PtInput from './input';
import PtInputNumber from './input-number';
import PtOption from './option';
import PtOptionGroup from './option-group';
import PtSelect from './select';
import PtTag from './tag';
import PtPopper from './popper';
import PtTooltip from './tooltip';
import PtVirtualized from './virtualized';
import PtTabs from './tabs';
import PtTabPane from './tab-pane/index';
import PtRadio from './radio/index';
import PtRadioButton from './radio-button/index';
import PtRadioGroup from './radio-group/index';
import PtForm from './form/index';
import PtFormItem from './form-item';
import PtAutocomplete from './autocomplete';
import PtDropdownMenu from './dropdown-menu';
import PtDropdownItem from './dropdown-item';
import PtDropdown from './dropdown';
import PtTable from './table';
import PtSwitch from './switch/index';
import PtCheckbox from './checkbox';
import PtCheckboxButton from './checkbox-button';
import PtCheckboxGroup from './checkbox-group';
import PtCollapse from './collapse';
import PtCollapseItem from './collapse-item';
import PtCollapseTransition from './collapse-transition';
import PtSkeleton from './skeleton';
import PtSkeletonItem from './skeleton-item';
import PtSpace from './space';
import PtDialog from './dialog';
import PtBreadcrumb from './breadcrumb';
import PtBreadcrumbItem from './breadcrumb-item';
import PtPagination from './pagination';
import PtPopover from './popover';
import PtMessage from './message';
import PtMultiSelect from './multi-select';
import PtCard from './card';
import PtTree from './tree';
import PtProgress from './progress';
import PtUpload from './upload';
import PtDatePicker from './date-picker';
import PtTimePicker from './time-picker';
import PtTimeSelect from './time-select';
import PtSortable from './sortable';
import PtLink from './link';
import PtSlider from './slider';
import Loading from './loading';
// import PtCascader from './cascader';
// import PtCascaderPanel from './cascader-panel';

import type { InstallOptions } from '../utils/config';
import { setConfig } from '../utils/config';

const components = [
    PtSortable.PtSortableDraggable,
    PtSortable.PtSortableContainer,
    PtAffix,
    PtAlert,
    PtAvatar,
    PtButton,
    PtButtonV2,
    PtButtonGroup,
    PtBacktop,
    PtIcon,
    PtRow,
    PtCol,
    PtScrollbar,
    PtInput,
    PtInputNumber,
    PtOption,
    PtOptionGroup,
    PtSelect,
    PtTag,
    PtPopper,
    PtTooltip,
    PtVirtualized,
    PtTabs,
    PtTabPane,
    PtRadio,
    PtRadioButton,
    PtRadioGroup,
    PtForm,
    PtFormItem,
    PtAutocomplete,
    PtDropdownMenu,
    PtDropdownItem,
    PtDropdown,
    PtTable,
    PtSwitch,
    PtCheckbox,
    PtCheckboxButton,
    PtCheckboxGroup,
    PtCollapse,
    PtCollapseItem,
    PtCollapseTransition,
    PtSkeleton,
    PtSkeletonItem,
    PtSpace,
    PtDialog,
    PtBreadcrumb,
    PtBreadcrumbItem,
    PtPagination,
    PtPopover,
    PtMessage,
    PtMultiSelect,
    PtCard,
    PtTree,
    PtProgress,
    PtUpload,
    PtDatePicker,
    PtTimePicker,
    PtTimeSelect,
    PtLink,
    PtSlider,
    // PtCascader,
    // PtCascaderPanel,
];

const defaultInstallOpt: InstallOptions = {
    size: '' as ComponentSize,
    zIndex: 2000,
};

const install = (app: App, opt: InstallOptions): void => {
    const option = Object.assign(defaultInstallOpt, opt);
    app.config.globalProperties.$ELEMENT = option;
    setConfig(option);

    components.forEach((component) => {
        app.component(component.name, component);
    });

    Loading.install(app);

    app.config.globalProperties.$loading = Loading.service;
};

export default {
    install,
};
